import React from 'react';

import { SubNavItem } from '../types';

import cx from 'clsx';
import styles from './SubNavigationSlot.module.scss';

interface SubNavigationSlotProps {
  item: SubNavItem;
  onClick: (event: React.MouseEvent<{}>) => void;
}

const SubNavigationSlot = ({ item, onClick }: SubNavigationSlotProps) => {
  const { state, title } = item;

  return (
    <div className={styles.slot} data-testid="subnavigation-slot">
      <a
        className={cx(
          styles.anchorLayer,
          styles.title,
          state === 'active' && styles.titleActive
        )}
        data-testid="subnavigation-slot-anchor-title"
        target="_self"
        rel={`${item.notIndexed ? 'nofollow' : ''}`}
        href={item.route_link}
        onClick={onClick}
      >
        {title}
      </a>
    </div>
  );
};

export default SubNavigationSlot;
